module.exports = __webpack_public_path__ + "img/swingVariabilityText3.bdb803ea.png";